import React, { useState } from "react";
import TunasLogo from "../../../icon/apotek-tunas-logo.png";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { Constant } from "../../../helper/constant";

const Login = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedShift, setSelectedShift] = useState({
    index: "0",
    value: "Pagi",
  });
  const listShift = [
    {
      index: "0",
      value: "Pagi",
    },
    {
      index: "1",
      value: "Siang",
    },
  ];

  const handleShift = (event) => {
    const selectedShiftObj = listShift.find(
      (shift) => shift.index === event.target.value
    );
    setSelectedShift(selectedShiftObj);
  };

  const handleChange = (e) => {
    setErrors("");
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const loginUser = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(Constant.BASE_API_URL + "/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password,
        }),
      });
      const json = await response.json();
      const data = json.data;
      if (!response.ok) {
        alert(data);
        setIsLoading(false);
      } else {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user_data", JSON.stringify(data));
        localStorage.setItem("staff_shift", selectedShift.index);
        navigate("/", { replace: true });
      }
    } catch {
      alert("Gagal login, silahkan coba lagi");
    }
  };

  const handleSubmit = (e) => {
    if (formData.username === "") {
      setErrors("Username harus di isi");
    } else if (formData.password === "") {
      setErrors("Password harus di isi");
    } else {
      loginUser();
    }
    e.preventDefault();
  };

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <div className="form-container">
        <img className="tunas_logo" alt="Tunas Healthcare" src={TunasLogo} />
        <form onSubmit={handleSubmit}>
          <label>Username</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
          />
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
          <div className="error-container">
            {errors && <p className="error">{errors}</p>}
          </div>
          <div className="dropdown-shift">
            <p className="dropdown-shift-title">Shift</p>
            <select
              value={selectedShift.index}
              onChange={handleShift}
              className="dropdown-select"
            >
              {listShift.map((shift) => (
                <option key={shift.index} value={shift.index}>
                  {shift.value}
                </option>
              ))}
            </select>
          </div>
          <input type="submit" value="Masuk" />
        </form>
      </div>
    </div>
  );
};

export default Login;
